import { AfterViewInit, Component, inject, OnInit, signal, WritableSignal, Input } from '@angular/core';
import { Card } from 'primeng/card';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'ems-course-player',
  imports: [Card, FormsModule],
  templateUrl: './course-player-example.html',
  styleUrl: './course-player-example.scss',
  standalone: true
})
export class CoursePlayerExample implements OnInit, AfterViewInit {

  @Input() courseId!: number;

  #http: HttpClient = inject(HttpClient);
  #sanitizer = inject(DomSanitizer);

  viewPrepared: WritableSignal<boolean> = signal(false);
  coursePlayerUrl: WritableSignal<SafeResourceUrl | null> = signal(null);

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {

    const apiUrl: string = 'learning/course/player/url';
    const body: any = {
      "rootTrackerId": this.courseId  // NOTE: WJK: Will be overridden server-side for demo purposes
    };

    this.#http.post<any>(apiUrl, body).subscribe({
      next: (response: any) => {
        this.coursePlayerUrl.set(this.#sanitizer.bypassSecurityTrustResourceUrl(response.coursePlayerUrl));  // TODO: WJK: Formalize the response class
        this.viewPrepared.set(true);
      },
      error: (errorResponse: HttpErrorResponse) => {
        window.alert(errorResponse.message);
      },
    });
  }

}
